module.exports = __webpack_public_path__ + "static/media/product-Anylocal.89643348.png";